// import React from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Home from "./Pages/Home";
// import ProductListing from "./Pages/MenHeadrer/ProductListing";
// import SignUp from "./Pages/Auth/SignUp";
// import DetailsPage from "./Pages/Products/DetailsPage";
// import CartSec from "./Pages/HeaderContent/CartSec";
// import Profile from "./Pages/AccountSec/Profile";
// import OrderHistory from "./Pages/AccountSec/OrderHistory";
// import Checkout from "./Pages/Checkout/Checkout";
// import ThreeD from "./Pages/ThreeD";
// import { Address } from "./Pages/AccountSec/Address";
// import AddAddress from "./Pages/AccountSec/AddAddress";
// import OrderDetails from "./Pages/AccountSec/OrderDetails";
// import ForgotPassward from "./Pages/Auth/ForgotPassward";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
// import PaymentSuccess from "./Pages/Checkout/PaymentSuccess";
// import ViewGlbPage from "./Pages/AccountSec/ViewGlbPage";
// import SizeTable from "./Pages/DetailsExtra/SizeTable";
// import WishList from "./Pages/HeaderContent/WishList";
//  import TeamOrder from "./Pages/Products/TeamOrder";
// import { FamilyOrder } from "./Pages/FamilyOrder";
// import { AllListingPage } from "./Pages/Products/AllListingPage";
// import BlogDetails from "./Pages/Blog/BlogDetails";
// import Blog from "./Pages/Blog/Blog";
// import About from "./Pages/HeaderContent/About";
// import Header from "./Pages/Components/Header";
// import EventOrder from "./Pages/EventOrder";
// import Dumy from "./Pages/Dumy";

// const stripePromise = loadStripe(
//   "pk_live_51QrOODP0AaPv7hClFSLvicJN0FpYmtZkpgZO9KUywXtwfhhiwjslFDAvTaAqIJqATeiyh7KomVVwGpy6GVOmGnsD00oWaOb4O8"
// );
// const options = {
//   mode: "payment",
//   currency: "usd",
//   amount: 1000,
// };

// function App() {
//   return (
//     <>
//       <Router>
//        <Header />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/dumy" element={<Dumy />} />
//         <Route
//           path="/productListing/:category/:subcategory/:menu/:categoryName/:subCategoryId/:subCategoryName"
//           element={<ProductListing />}
//         />
// <Route path="/detailsPage/:productSlug" element={<DetailsPage />} />
// <Route path="/detailsPage/:productSlug/:isTeam" element={<DetailsPage />} />
//         <Route path="/auth" element={<SignUp />} />
       

//         <Route path="/cart" element={<CartSec />} />
//         <Route path="/profile" element={<Profile />} />
//         <Route path="/orderHistory" element={<OrderHistory />} />
//         <Route
//           path="/checkout"
//           element={
//             <Elements stripe={stripePromise} options={options}>
//               <Checkout />
//             </Elements>
//           }
//         />
//         <Route path="/3d-product" element={<ThreeD />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/addresses" element={<Address />} />
//         <Route path="/add-addresses" element={<AddAddress />} />
//         <Route path="/order-details" element={<OrderDetails />} />
//         <Route path="/forgot-password" element={<ForgotPassward />} />
//         <Route path="/verify-payment" element={<PaymentSuccess />} />
//         <Route path="/customizer" element={<ViewGlbPage />} />
//         <Route path="/size-table" element={<SizeTable />} />
//         <Route path="/wishlist" element={<WishList />} />
//         <Route path="/team-order" element={<TeamOrder />} />
//         <Route path="/event-order" element={<EventOrder />} />
//         <Route path="/family-order" element={<FamilyOrder />} />
//         <Route path="/AllListingPage" element={<AllListingPage />} />
//         <Route path="/blog/:slug" element={<BlogDetails />} />
//         <Route path="/blog" element={<Blog />} />
//       </Routes>
//     </Router>
//     </>
//   );
// }

// export default App;

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import ProductListing from "./Pages/MenHeadrer/ProductListing";
import SignUp from "./Pages/Auth/SignUp";
import DetailsPage from "./Pages/Products/DetailsPage";
import CartSec from "./Pages/HeaderContent/CartSec";
import Profile from "./Pages/AccountSec/Profile";
import OrderHistory from "./Pages/AccountSec/OrderHistory";
import Checkout from "./Pages/Checkout/Checkout";
import ThreeD from "./Pages/ThreeD";
import { Address } from "./Pages/AccountSec/Address";
import AddAddress from "./Pages/AccountSec/AddAddress";
import OrderDetails from "./Pages/AccountSec/OrderDetails";
import ForgotPassward from "./Pages/Auth/ForgotPassward";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentSuccess from "./Pages/Checkout/PaymentSuccess";
import ViewGlbPage from "./Pages/AccountSec/ViewGlbPage";
import SizeTable from "./Pages/DetailsExtra/SizeTable";
import WishList from "./Pages/HeaderContent/WishList";
import TeamOrder from "./Pages/Products/TeamOrder";
import { FamilyOrder } from "./Pages/FamilyOrder";
import { AllListingPage } from "./Pages/Products/AllListingPage";
import BlogDetails from "./Pages/Blog/BlogDetails";
import Blog from "./Pages/Blog/Blog";
import About from "./Pages/HeaderContent/About";
import Header from "./Pages/Components/Header";
import EventOrder from "./Pages/EventOrder";
import Dumy from "./Pages/Dumy";
import Loader from "./Pages/Loader/Loader";

// Remove these lines:
// import { createRequire } from 'module';
// const require = createRequire(import.meta.url);

const stripePromise = loadStripe(
  "pk_live_51QrOODP0AaPv7hClFSLvicJN0FpYmtZkpgZO9KUywXtwfhhiwjslFDAvTaAqIJqATeiyh7KomVVwGpy6GVOmGnsD00oWaOb4O8"
);
const options = {
  mode: "payment",
  currency: "usd",
  amount: 1000,
};

export const LoadingContext = React.createContext();

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {isLoading ? (
        <Loader />
      ) : (
        <Router>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dumy" element={<Dumy />} />
            <Route
              path="/productListing/:category/:subcategory/:menu/:categoryName/:subCategoryId/:subCategoryName"
              element={<ProductListing />}
            />
            <Route path="/detailsPage/:productSlug" element={<DetailsPage />} />
            <Route path="/detailsPage/:productSlug/:isTeam" element={<DetailsPage />} />
            <Route path="/auth" element={<SignUp />} />
            <Route path="/cart" element={<CartSec />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/orderHistory" element={<OrderHistory />} />
            <Route
              path="/checkout"
              element={
                <Elements stripe={stripePromise} options={options}>
                  <Checkout />
                </Elements>
              }
            />
            <Route path="/3d-product" element={<ThreeD />} />
            <Route path="/about" element={<About />} />
            <Route path="/addresses" element={<Address />} />
            <Route path="/add-addresses" element={<AddAddress />} />
            <Route path="/order-details" element={<OrderDetails />} />
            <Route path="/forgot-password" element={<ForgotPassward />} />
            <Route path="/verify-payment" element={<PaymentSuccess />} />
            <Route path="/customizer" element={<ViewGlbPage />} />
            <Route path="/size-table" element={<SizeTable />} />
            <Route path="/wishlist" element={<WishList />} />
            <Route path="/team-order" element={<TeamOrder />} />
            <Route path="/event-order" element={<EventOrder />} />
            <Route path="/family-order" element={<FamilyOrder />} />
            <Route path="/AllListingPage" element={<AllListingPage />} />
            <Route path="/blog/:slug" element={<BlogDetails />} />
            <Route path="/blog" element={<Blog />} />
          </Routes>
        </Router>
      )}
    </LoadingContext.Provider>
  );
}

export default App;